import type {Recipe} from './types';

export const crescenteBolognese: Recipe = {
    id: 13,
    key: "crescenteBolognese",
    pictures: [
        {index: 0, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2022/03/Crescente-bolognese-0D6A1879-1200x675.jpg"},
        {index: 4, url: "https://www.cucchiaio.it/content/cucchiaio/it/ricette/2014/07/ricetta-crescente-bolognese/jcr:content/procedure-par/recipe_procedures_2/image.img3.jpg/1650312206923.jpg"},
    ],
    i18n: {
        IT: {
            title: "Crescente Bolognese",
            servings: "Numero di porzioni non specificato",
            ingredients: [
                "500 grammi di farina 00",
                "250 grammi di acqua (circa)",
                "25 grammi di lievito di birra",
                "150 grammi di prosciutto crudo o pancetta, tritato grossolano",
                "50 grammi di strutto",
                "8 grammi di sale (un cucchiaio colmo)",
                "mezzo cucchiaino di zucchero",
            ],
            steps: [
                "Fare la fontana con gli ingredienti e impastare velocemente formando una palla.",
                "Coprire e lasciare lievitare per 50-60 minuti.",
                "Stendere la pasta senza lavorarla formando un ovale di circa 1,5 cm di spessore e disporla su una teglia.",
                "Pizzicare tutto intorno, tracciare delle losanghe sulla superficie con una lametta, spennellare con uovo e lasciare lievitare per altri 50 minuti.",
                "Cuocere in forno pre-riscaldato a 200-210 °C per 40-45 minuti.",
            ],
        },
        EN: {
            title: "Crescente Bolognese chleb",
            servings: "Number of servings not specified",
            ingredients: [
                "500 grams of 00 flour",
                "250 grams of water (approx.)",
                "25 grams of fresh yeast",
                "150 grams of prosciutto or pancetta, coarsely chopped",
                "50 grams of lard",
                "8 grams of salt (a heaping tablespoon)",
                "half a teaspoon of sugar",
            ],
            steps: [
                "Make a well with the ingredients and knead quickly to form a ball.",
                "Cover and let rise for 50-60 minutes.",
                "Roll out the dough without working it, forming an oval about 1.5 cm thick and place it on a baking sheet.",
                "Pinch all around, score diamonds on the surface with a razor blade, brush with egg, and let rise for another 50 minutes.",
                "Bake in a preheated oven at 200-210 °C for 40-45 minutes.",
            ],
        },
        PL: {
            title: "Crescente Bolognese bread",
            servings: "Liczba porcji nieokreślona",
            ingredients: [
                "500 gramów mąki 00",
                "250 gramów wody (około)",
                "25 gramów świeżych drożdży",
                "150 gramów szynki prosciutto lub pancetty, grubo posiekanej",
                "50 gramów smalcu",
                "8 gramów soli (czubata łyżka)",
                "pół łyżeczki cukru",
            ],
            steps: [
                "Zrób zagłębienie w mące i szybko zagnieć ciasto w kulę.",
                "Przykryj i pozostaw do wyrośnięcia na 50-60 minut.",
                "Rozwałkuj ciasto bez zagniatania, formując owal o grubości około 1,5 cm i umieść go na blasze do pieczenia.",
                "Uszczypnij brzegi, ponacinaj powierzchnię w romby żyletką, posmaruj jajkiem i pozostaw do wyrośnięcia na kolejne 50 minut.",
                "Piec w nagrzanym piekarniku w temperaturze 200-210 °C przez 40-45 minut.",
            ],
        },
    },
};
